import { createWebHistory, onBeforeRouteLeave } from 'vue-router'

const SHOP_BASE_URL = window.__SHOP_BASE_URL__ || ''
// 默认路由，用于国内，海外主站
const defaultRouter = {
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/AppHome/index.vue'),
      meta: {
        keepAlive: true,
        scrollTopClose: true,
        optionList: ['post', 'qrcode', 'top']
        // depth: 3
      }
    },
    {
      path: '/content/:contentId',
      name: 'contentDetail',
      component: () => import('@/views/AppContentDetail/AppContentDetail.vue'),
      props: (route: any) => ({ pageSource: (route.query?.pageSource as string) || '' }),
      meta: {
        needFooter: false,
        needHeader: false
      }
    },
    {
      path: '/seriesDetail/:uniqueSeriesId/:uniqueContentId?',
      name: 'seriesDetail',
      component: () => import('@/views/AppSeriesDetail/AppSeriesDetail.vue'),
      meta: {
        needFooter: false,
        needHeader: false
      }
    },
    {
      path: '/challenge/:challengeId',
      name: 'challengeDetail',
      component: () => import('@/views/AppChallengeDetail/AppChallengeDetail.vue'),
      meta: {
        needHeader: true,
        needFooter: false,
        keepAlive: true,
        optionList: ['create', 'top']
      }
    },
    {
      path: '/challenge/design/:challengeId',
      name: 'challengeDesign',
      meta: {
        needHeader: false,
        needFooter: false
      },
      component: () => import('@/views/AppChallengeDesign/AppChallengeDesign.vue')
    },
    {
      path: '/challenge/share/:contentId',
      name: 'challengeShare',
      meta: {
        needFooter: false
      },
      component: () => import('@/views/AppShare.vue')
    },
    {
      path: '/feeds',
      name: 'feeds',
      component: () => import('@/views/AppHome/index.vue'),
      meta: {
        keepAlive: true,
        optionList: ['post', 'qrcode', 'top']
      }
    },
    {
      path: '/all-activities',
      name: 'all-activities',
      component: () => import('@/views/AppAllActivities/AppAllActivities.vue')
    },
    {
      path: '/generator',
      name: 'generator',
      meta: {
        needHeader: false
      },
      redirect: '/generator/image',
      component: () => import('@/views/GenerateTool/index.vue'),
      children: [
        {
          path: 'image',
          name: 'generatorImage',
          component: () => import('@/views/AppGenerator/GeneratorImage/index.vue'),
          meta: {
            needHeader: false
          }
        },
        {
          path: 'inpainting',
          name: 'generatorInpainting',
          meta: {
            needHeader: false
          },
          component: () => import('@/views/AppGenerator/GeneratorInpainting/index.vue')
        },
        // {
        //   path: '3d',
        //   name: 'generator3D',
        //   meta: {
        //     needHeader: false
        //   },
        //   component: () => import('@/views/AppGenerator/Generator3D/index.vue')
        // },
        {
          path: 'hd',
          name: 'generatorHD',
          meta: {
            needHeader: false,
            needFooter: false
          },
          component: () => import('@/views/AppGenerator/GeneratorHD/index.vue')
        },
        {
          path: 'img2img',
          name: 'generatorImg2Img',
          meta: {
            needHeader: false,
            needFooter: false
          },
          component: () => import('@/views/AppGenerator/GeneratorImg2Img/index.vue')
        },
        {
          path: 'video',
          name: 'generatorVideo',
          meta: {
            needHeader: false,
            needFooter: false
          },
          component: () => import('@/views/AppGenerator/GeneratorVideo/index.vue')
        }
      ]
    },

    {
      path: '/terms',
      name: 'terms',
      component: () => import('@/views/ApplicationTerms.vue')
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import('@/views/AppPrivacyPolicy.vue')
    },
    {
      path: '/account/:userId?',
      name: 'account',
      meta: {
        needLogin: true,
        keepAlive: true,
        depth: 1
      },
      component: () => import('@/views/AppAccount/AppAccount.vue')
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        needFooter: false
      },
      component: () => import('@/views/AppLogin.vue')
    },
    {
      path: '/docs/:name?',
      name: 'docs',
      meta: {
        needHeader: false
      },
      component: () => import('@/views/AppDocs/index.vue')
    },
    {
      path: '/information/:msgId',
      name: 'information',
      component: () => import('@/views/AppInformation/AppInformation.vue')
    },
    {
      path: '/make-real',
      name: 'makeReal',
      component: () => import('@/views/AppActivities/AppMakeItReal/AppMakeItReal.vue')
    },
    {
      path: '/courseForMakeIt',
      name: 'courseForMakeIt',
      meta: {
        footerDelay: 0
      },
      component: () => import('@/views/AppActivities/AppCourseForMakeIt/AppCourseForMakeIt.vue')
    },
    {
      path: '/delivery',
      name: 'deliverypage',
      meta: {
        needLogin: true,
        needFooter: false
      },
      component: () => import('@/views/AppDeliveryPage/AppDeliveryPage.vue')
    },
    {
      path: '/wx-pay',
      name: 'wxPay',
      component: () => import('@/components/AppWxPay/index.vue'),
      meta: {
        needFooter: false
      }
    },
    {
      path: '/wx-pay/h5-pay',
      name: 'wxH5Pay',
      component: () => import('@/components/AppWxPay/components/AppWxH5Pay.vue'),
      meta: {
        needFooter: false
      }
    },
    {
      path: '/wx-pay/callback/:orderId',
      name: 'wxH5PayCallback',
      component: () => import('@/components/AppWxPay/components/AppWxH5PayCallback.vue'),
      meta: {
        needHeader: false,
        needFooter: false
      }
    },
    {
      path: '/wx-pay/result/:result',
      name: 'wxPayResult',
      component: () => import('@/components/AppWxPay/components/AppWxPayResultPage.vue'),
      meta: {
        allowedFrom: ['/wx-pay'],
        needFooter: false
      }
    },
    {
      path: '/generator/dreamJob',
      name: 'AppGeneratorDreamJob',
      meta: {
        needHeader: false,
        keepAlive: true,
        needFooter: false,
        depth: 3
      },
      component: () => import('@edu/views/AppGeneratorDreamJob/index.vue')
    },
    {
      path: '/create/cartoonFigurine',
      name: 'createCartoonFigurine',
      meta: {
        needHeader: false,
        needFooter: false
      },
      component: () => import('@/views/AppEduPages/views/AppCreateCartoonFigurine/index.vue')
    },
    {
      path: '/generator/imageTo3D',
      name: 'generatorImageTo3D',
      meta: {
        needHeader: false,
        needFooter: false
      },
      component: () => import('@edu/views/AppGeneratorImageTo3D/index.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/AppAboutUs/AppAboutUs.vue')
    },
    {
      path: '/tool',
      name: 'tool',
      component: () => import('@/views/AppTool/AppTool.vue')
    },
    {
      path: '/createUpgrade',
      name: 'createUpgrade',
      component: () => import('@/views/AppCreateUpgrade/AppCreateUpgrade.vue')
    },
    {
      path: '/customer/account/:userId?',
      name: 'customerAccount',
      component: () => import('@/views/AppAccount/AppAccount.vue')
    },
    // {
    //   path: '/order',
    //   meta: {
    //     needLogin: true,
    //     needFooter: false
    //   },
    //   children: [
    //     {
    //       path: 'list',
    //       name: 'orderList',
    //       component: () => import('@/views/AppOrder/AppOrderList.vue')
    //     },
    //     {
    //       path: 'detail/:orderId',
    //       name: 'orderDetail',
    //       component: () => import('@/views/AppOrder/AppOrderDetail.vue')
    //     },
    //     {
    //       path: 'redirect/:orderId',
    //       name: 'orderWxDetail',
    //       component: () => import('@/views/AppOrder/AppOrderWxBridgeDetail.vue')
    //     },
    //     {
    //       path: 'logistics/:orderId',
    //       name: 'logistics',
    //       component: () => import('@/views/AppOrder/AppOrderLogistics.vue')
    //     }
    //   ]
    // },
    {
      path: '/activities/xiaohongshu/:code',
      name: 'xiaohongshuActivities',
      component: () =>
        import('@/views/AppActivities/AppActivitiyXiaoHongShu/AppActivitiyXiaoHongShu.vue'),
      meta: {
        needHeader: true,
        needFooter: false
      }
    },
    {
      path: '/activities/yincangkuan/:code',
      name: 'yincangkuanActivities',
      component: () =>
        import('@/views/AppActivities/AppActivitiyYinCangKuan/AppActivitiyYinCangKuan.vue'),
      meta: {
        needHeader: true,
        needFooter: false
      }
    },
    {
      path: '/author/onboarding',
      name: 'authorOnboarding',
      component: () => import('@/views/AppAuthorOnboarding/AppAuthorOnboarding.vue'),
      meta: {
        needHeader: true,
        needFooter: true
      }
    },
    {
      path: '/creator',
      name: 'creator',
      component: () => import('@/views/AppCreator/index.vue')
    },
    {
      path: '/search-result',
      name: 'searchResult',
      component: () => import('@/views/AppSearchResult/AppSearchResult.vue')
    },
    {
      path: '/creatorDetail/',
      name: 'creatorDetail',
      meta: {
        needHeader: false,
        needLogin: true
      },
      component: () => import('@/views/AppCreatorDetail/index.vue')
    },
    {
      path: '/my-history',
      name: 'myHistory',
      meta: {
        needHeader: true,
        needLogin: true
      },
      component: () => import('@/views/AppMyHistory/index.vue')
    },
    {
      path: '/artist/daidunbang',
      name: 'artistDaidunbang',
      component: () => import('@/views/AppArtistDaidunbang/index.vue'),
      meta: {
        needHeader: true,
        needFooter: false,
        needLogin: false
      }
    },
    {
      path: '/designer/product/release',
      name: 'designerProductRelease',
      meta: {
        needHeader: true,
        needFooter: false,
        needLogin: true
      },
      component: () => import('@/views/DesignerProductRelease/index.vue')
    },
    // 其他路由 *，如果是电商的路由，例如：/productDetail 跳转到电商系统
    {
      path: '/:catchAll(.*)',
      name: 'other',
      beforeEnter() {
        if (window.location.pathname.indexOf('/productDetail') > -1) {
          window.location.href =
            SHOP_BASE_URL + window.location.pathname.replace('/productDetail', '/detail')
        }
        if (window.location.pathname.indexOf('/order/detail/') > -1) {
          window.location.href = SHOP_BASE_URL + window.location.pathname
        }
      }
    }
  ]
}

export default defaultRouter
